import React, { useState } from 'react';
import { formatMomentDate } from "../../../../../utils/dateHelper";
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { EditIcon, Delete02Icon, PlusIcon } from '../../../../../assets/icons';
import CertificationModal from '../../../../../components/modals/UserProfile/CertificationModal';
import DeletePopup from '../../../../../components/delete-popup';
import { addUserCertification, updateUserCertification, deleteUserCertification } from '../../../../../redux/slice/allUsersSlice';
import PreviewModal from '../../../../../components/modals/previewModal';
import { useToast } from '../../../../../context/TostContext';
import { IconBtn } from '../../../../../components/commonButton/btns';
import { UserInital } from '../../../../../utils/otherHelopers';

const Certifications = ({ userDetail }) => {
    const {id} = useParams();
    const dispatch = useDispatch();
    const toast = useToast();
    const [showModal, setShowModal] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);
    const [showPreviewModal, setShowPreviewModal] = useState(false);
    const [previewMediaArray, setPreviewMediaArray] = useState([]);

    const { certificationLoading } = useSelector((state) => state.allUsers);

    const handleUpsertCertification = (data) => {
        const action = currentItem
            ? updateUserCertification({ id: id, certificationId: currentItem.id, data })
            : addUserCertification({ id: id, data });

        dispatch(action)
            .unwrap()
            .then(() => {
                toast.success(`Certification ${currentItem ? "updated" : "added"} successfully`);
                setShowModal(false);
                setCurrentItem(null);
            })
            .catch((error) => {
                toast.error(error?.message || `Failed to ${currentItem ? "update" : "add"} certification`);
            });
    };

    const handleDeleteCertification = () => {
        dispatch(deleteUserCertification({ id: id, certificationId: itemToDelete }))
            .unwrap()
            .then(() => {
                toast.success("Certification deleted successfully");
                setShowDeletePopup(false);
                setItemToDelete(null);
            })
            .catch((error) => {
                toast.error(error?.message || "Failed to delete certification");
            });
    };

    return (
        <div className="position-relative h-100">
            <div className="d-flex align-items-center justify-content-between mb-4">
                <h6 className="fw-bold mb-0" style={{ fontSize: '18px' }}>Certification</h6>
                <IconBtn size={32} icon={<PlusIcon size={16} />} className='rounded-circle' onClick={() => {
                    setCurrentItem(null);
                    setShowModal(true);
                }} />

            </div>
            {userDetail?.certifications?.length > 0 ? (
                <div className="d-flex flex-column gap-3">
                    {userDetail.certifications.map((cert, index) => (
                        <div key={index} className="p-3 border rounded-3 bg-light-subtle position-relative custom-card">
                            <div className="position-absolute top-0 end-0 p-2 d-flex gap-2">
                                <button
                                    className="post-action-btn edit-btn border bg-white"
                                    onClick={() => {
                                        setCurrentItem(cert);
                                        setShowModal(true);
                                    }}
                                >
                                    <EditIcon width={14} height={14} color="#007bff" />
                                </button>
                                <button
                                    className="post-action-btn delete-btn border bg-white"
                                    onClick={() => {
                                        setItemToDelete(cert.id);
                                        setShowDeletePopup(true);
                                    }}
                                >
                                    <Delete02Icon size={14} />
                                </button>
                            </div>
                            <div className="d-flex gap-3 align-items-start">
                                <UserInital width={56} image={cert.file?.url} name={cert.title} onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setPreviewMediaArray([{
                                        url: cert.file.url,
                                        title: cert.title || "Certification Image",
                                        type: "image"
                                    }]);
                                    setShowPreviewModal(true);
                                }}
                                    onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }} />

                                <div className="flex-grow-1">
                                    <h6 className="mb-1 fw-bold text-dark fs-6">{cert.title || "-"}</h6>
                                    <p className="mb-2 text-muted fw-medium" style={{ fontSize: '13px' }}>{cert.provider || "-"}</p>
                                    <div className="d-flex align-items-center flex-wrap gap-2 text-muted" style={{ fontSize: '12px' }}>
                                        <span>Issued {cert.issued_date ? formatMomentDate(cert.issued_date, "MMM YYYY") : "-"}</span>
                                        {cert.credential_id && (
                                            <>
                                                <span style={{ fontSize: '16px', lineHeight: 1 }}>•</span>
                                                <span>Credential ID: {cert.credential_id}</span>
                                            </>
                                        )}
                                    </div>
                                    {cert.credential_url && (
                                        <a href={cert.credential_url} target="_blank" rel="noopener noreferrer" className="small text-primary text-decoration-none fw-semibold mt-2 d-inline-block">View Credential</a>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="text-center py-5 text-muted">
                    <p className="mb-0">No certifications listed.</p>
                </div>
            )}

            <CertificationModal
                isOpen={showModal}
                onClose={() => {
                    setShowModal(false);
                    setCurrentItem(null);
                }}
                onSubmit={handleUpsertCertification}
                certification={currentItem}
                isLoading={certificationLoading}
                title={currentItem ? "Edit Certification" : "Add Certification"}
                size="lg"
            />

            <DeletePopup
                show={showDeletePopup}
                onHide={() => {
                    setShowDeletePopup(false);
                    setItemToDelete(null);
                }}
                onConfirm={handleDeleteCertification}
                content="Are you sure you want to delete this certification?"
                saveTitle="Delete"
                disabled={certificationLoading}
            />

            <PreviewModal
                show={showPreviewModal}
                onHide={() => setShowPreviewModal(false)}
                previewMedia={previewMediaArray}
                initialIndex={0}
            />
        </div>
    );
};

export default Certifications;
